export default {
    name: 'errors',
    error: 'error',
};
